import { create } from 'zustand'

interface AuthState {
  isReady: boolean
  isLoggedIn: boolean
  userId: string
  svrId: string
  brokerId: string
  pendingAgreementTypes: string[]
  setReady: (value: boolean) => void
  setLoggedIn: (value: boolean) => void
  setUserId: (userId: string) => void
  setSvrId: (svrId: string) => void
  setBrokerId: (brokerId: string) => void
  setPendingAgreementTypes: (types: string[]) => void
  clearPendingAgreementTypes: () => void
}

export const useAuthStore = create<AuthState>()(set => ({
  isReady: false,
  isLoggedIn: false,
  userId: '',
  svrId: '',
  brokerId: '',
  pendingAgreementTypes: [],
  setReady: value => set({ isReady: value }),
  setLoggedIn: value => set({ isLoggedIn: value }),
  setUserId: userId => set({ userId }),
  setSvrId: svrId => set({ svrId }),
  setBrokerId: brokerId => set({ brokerId }),
  setPendingAgreementTypes: types => set({ pendingAgreementTypes: types }),
  clearPendingAgreementTypes: () => set({ pendingAgreementTypes: [] }),
}))
